module.exports = __webpack_public_path__ + "static/img/fy.b6781d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/fy.png
// module id = 2F0z
// module chunks = 1